"use client";

import { useRouter } from "next/navigation";
import { cn } from "@/lib/utils";

interface BackButtonProps {
  label?: string;
  onClick?: () => void;
  className?: string;
}

export function BackButton({
  label = "",
  onClick,
  className,
}: BackButtonProps) {
  const router = useRouter();

  return (
    <button
      onClick={onClick || (() => router.back())}
      className={cn(
        "inline-flex items-center gap-2 text-gray-400 hover:text-white",
        className
      )}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z"
          fill="currentColor"
        />
      </svg>
      {label && <span className="text-base">{label}</span>}
    </button>
  );
}
